export interface BotLicense {
  label: string;
  value: string;
}

export enum AppLicense {
  KZ = 'kz',
  COM = 'com',
  WL = 'wl',
}
